import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-job-company',
  templateUrl: './page-job-company.component.html',
  styleUrls: ['./page-job-company.component.css'],
  standalone: false,
})
export class PageJobCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
